export default __webpack_public_path__ + "static/Poppins-LightItalic-11788d6e1b1f5b356362525cc764e960.woff2";